import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Landing, medigiLanding, medshortsLanding } from '../models/landing';
import { environment } from 'src/environments/environment';
import themes from 'devextreme/ui/themes';
import { UserService } from 'src/app/shared/services/user/user.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root',
})
export class AppInfoService {
  private landingDataSubject = new BehaviorSubject<Landing>(null);
  configs: Landing;
  // Cached: a template getter runs on every change-detection pass, and this one
  // parses the stored client JSON. Cleared in setDomainConfigs(), which auth0
  // calls right after it rewrites msClient (impersonation included).
  private _supportEmail: string | null = null;
  windowURL = window.location.host;

  constructor(
    private userService: UserService,
    private storageService: StorageService,
  ) {
    this.setDomainConfigs();
  }

  public get(): BehaviorSubject<Landing> {
    return this.landingDataSubject;
  }

  public get theme(): string {
    return this.configs.theme;
  }

  /**
   * Address to show a user who needs to contact us.
   *
   * The tenant's own address when the client record has one, else the brand default.
   * Never hardcode `info@medigi.com` at a call site — a white-label seller is then
   * told to email medigi (MDG-104).
   */
  public get supportEmail(): string {
    if (this._supportEmail === null) {
      const client = this.userService.getClientFromStorage();
      this._supportEmail =
        client?.comm_email || this.configs?.contacts?.email || 'info@medigi.com';
    }
    return this._supportEmail;
  }

  public setDomainConfigs() {
    this._supportEmail = null;
    // Grab the env file based settings
    if (location.host.includes('medshorts.com')) {
      this.configs = medshortsLanding;
    } else {
      this.configs =
        environment.availableThemes[this.windowURL] || medigiLanding;
    }
    themes.current(this.configs.theme);

    // Add any Client info
    // Client data is set after auth0 authenticates on startup...
    const client = this.userService.getClientFromStorage();
    if (client) {
      // Should mean the domain matched the client record
      if (
        this.windowURL.startsWith(client['hostkey']) &&
        client['company_id']
      ) {
        // Lock down to this seller until the domain changes
        this.storageService.set('catalogSellerId', client['company_id']);
        this.storageService.set('catalogSellerLocked', 'true');
      }
    } else {
      this.configs.client = false;
      // Clean up local storage if the client changes
      this.storageService.remove('catalogSellerId');
      this.storageService.set('catalogSellerLocked', 'false');
    }

    this.configs.client = client;
    return this.landingDataSubject.next(this.configs);
  }
}
